import { Typography } from 'antd'
import { CIMSTabs } from 'components/CIMSTabs'
import { PDFDesignLayerType } from './types'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Permission } from '@cims-online/shared'
import TabContent from './components/TabContent'

const PDFDesignLayers: React.VFC = () => {
  return (
    <CIMSTabs
      prefix={
        <>
          <Typography.Text>
            Many PDF Reports generate an image composed of satellite imagery,
            project specific feature layers, and feature geometries specific to
            the report.
          </Typography.Text>
          {useCheckPermission(Permission.EditPDFDesignLayer) && (
            <>
              <Typography.Text>
                Configure which project specific feature layers to show for each
                option and its associated values below.
              </Typography.Text>
              <Typography.Text>
                Even if global and per record configurations are stored in the
                database, the "Use All" setting will determine which to use when
                generating an image on a PDF Report.
              </Typography.Text>
            </>
          )}
        </>
      }
      sort
      initialTab="AsphaltMaterial"
      tabs={Object.keys(PDFDesignLayerType).map((key) => {
        const typename = key as keyof typeof PDFDesignLayerType
        return {
          label: PDFDesignLayerType[typename].names,
          key: typename,
          component: (
            <div style={{ marginTop: -20 }}>
              <TabContent typename={typename} />
            </div>
          ),
        }
      })}
    />
  )
}

export default PDFDesignLayers
